import React, { useState, useEffect } from "react";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Chart as ChartJS, ArcElement, Tooltip as ChartTooltip, Legend } from "chart.js";//TM
import { Pie } from "react-chartjs-2";
import { InvoiceAPI } from "../../services/dbApi";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import "./AdminDashboard.css";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { Card, CardMedia, CardActions } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import InvoiceForm from "../invoice_form/InvoiceForm";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import moment, { now } from "moment";
//24-07-2025 TM
import RateReviewRoundedIcon from "@mui/icons-material/RateReviewRounded";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import Tooltip from "@mui/material/Tooltip";

// {
//   userID;
// }
const AdminDashboard = ({
  setCurrentTab,
  currentTab,
  setSelectedInvoice,
  invoiceSuccess,
}) => {
  const navigate = useNavigate();

  const userdetails = useSelector((state) => state.userdetails);
  /**- Error Handling -**/
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [BusinessList, setBusinessList] = useState([]);
  const [PartnerGSTList, setPartnerGSTList] = useState([]);


  const partnerAllBusiness = async (userId) => {
    try {
      const res = await InvoiceAPI.businessAll(userId);
      setBusinessList(res?.data?.result);
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const partnersGST = async (userId) => {
    //handleFilterChange(e);
    try {
      const res = await InvoiceAPI.partnersGSTAll(userID);
      setPartnerGSTList(res?.data?.result);
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  //

  const [errorMessage, setErrorMessage] = useState("");
  /**- Invoice States -**/
  const [invoiceList, setInvoiceList] = useState();


  const [businessCodeList, setBusinessCodeList] = useState(); //ak
  const [businessAllGst, setBusinessAllGst] = useState(); //ak
  const userID = userdetails?.userData?.userID; //ak
  const notifyType = () =>
    toast.info(<h4>If Document No and Type Same Cant Be Updated</h4>, {
      autoClose: 3000,
      pauseOnHover: true,
      draggable: true,
      position: "top-right",
    });

  const Invoices = async (userId) => {
    try {
      setLoading(true);
      setError(false);
      const res = await InvoiceAPI.Invoices(userId);
      setInvoiceList(res?.data?.result);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        setErrorMessage(error?.response?.data?.message);
      } else {
        setErrorMessage(
          "Internal Server Isssue,Apologies for the inconvenience caused!"
        );
      }
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    // Invoices(userID[0]);
    partnerAllBusiness(userID);
    partnersGST(userID);
    Invoices(userdetails.userData.userID);
  }, [userdetails.userData.userID]); // [inside this by ak]
  const data = [
    { name: "Group A", value: 400 },
    { name: "Group B", value: 300 },
    { name: "Group C", value: 300 },
    { name: "Group D", value: 200 },
  ];
  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
  const TABLE_HEADS = [
    //"InvoiceID",
    "Lob",
    "Document No",
    "Document Date",
    "Document Type",
    "Document Total",
    "Invoice Status",
    "Processing Status",
    "Rejected Remarks",
    "Payment Status",
    "UTR Details",

    // "Action",
  ];
  const TABLE_DATA = invoiceList || [];

  // ChartJS.register(ArcElement, Tooltip, Legend);
  ChartJS.register(ArcElement, ChartTooltip, Legend);//TM

  const datas = {
    labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
    datasets: [
      {
        label: "# of Votes",
        data: [12, 19, 3, 5, 2, 3],
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const handleDraftClick = async (invoice_id) => {
    try {
      const res = await InvoiceAPI.InvoicesDraft(invoice_id);
      setSelectedInvoice(res.data.result[0]);
      setCurrentTab(1);
    } catch (error) {
      console.log("failed to pre-populate the draft fields", error);
    }
  };

  const [Filters, setFilters] = useState({
    partner_code: "",
    lob: "",
    gst: "",
    month: "",
    invoice_status: "",
    invoice_type: "",
  });
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  function FilterDate(name) {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ["month"]: moment(name).format("MM-YYYY"),
    }));
  }

  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear();
    const tooltipText = `Tooltip for month: ${longMonth} ${fullYear}`;

    return <span title={tooltipText}>{shortMonth}</span>;
  };

  const SearchInvoices = async (
    Partner_Code,
    Lob,
    Gst,
    Invoice_Status,
    Invoice_Type,
    Month
  ) => {
    invoiceSuccess.isDraft = "nostatus";
    invoiceSuccess.isInvoiceUploaded = "nostatus";



    setLoading(true);
    setError(false);
    try {
      setLoading(true); // Start loading state
      const res = await InvoiceAPI.SearchInvoices(
        Partner_Code,
        Lob,
        Gst,
        Invoice_Status,
        Invoice_Type,
        Month
      );
      setInvoiceList(res?.data?.result || []);
    } catch (error) {
      if (error.response?.status === 401) {
      } else {
        console.error("Error while fetching invoices:", error.message);
      }
      setInvoiceList([]);
    } finally {
      setLoading(false);
    }

    //test ends
  };



  return (
    <>

      <h4 className="data-table-title"></h4>
      <table class="invoice-form-input-field-filter">
        <tr>
          <th>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Partner Code
            <span style={{ color: "red" }}> *</span>
          </th>
          <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Businesss
            <span style={{ color: "red" }}> *</span>
          </th>
          <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;GST</th>
          <th>&nbsp;&nbsp;&nbsp;Invoice Status</th>
          <th>&nbsp;&nbsp;&nbsp;Invoice Type</th>
          <th>&nbsp;&nbsp;&nbsp;Month</th>
        </tr>

        <tr>
          <td>
            <select
              name="partner_code"
              display="PARTNER CODE"
              value={Filters.partner_code}
              onChange={handleFilterChange}
            >
              <option value="NOSELECTION">Select Partner Code</option>
              <option value={userID}>{userID}</option>
            </select>
          </td>

          <td>
            <select
              name="lob"
              display="LOB"
              value={Filters.lob}
              onChange={(e) => {
                handleFilterChange(e);
              }}
            >
              <option value="NOSELECTION">Select LOB</option>
              {BusinessList?.map((lob) => (
                <option value={lob.business_code}>{lob.business_code}</option>
              ))}
            </select>
          </td>
          <td>
            <select
              name="gst"
              value={Filters.gst}
              onChange={(e) => {
                handleFilterChange(e);
              }}
            >
              <option value="NOSELECTION">Select GSTIN</option>
              {PartnerGSTList?.map((gstin) => (
                <option value={gstin.gst_no}>{gstin.gst_no}</option>
              ))}
            </select>
          </td>
          <td>
            <select
              name="invoice_status"
              value={Filters.invoice_status}
              onChange={handleFilterChange}
            >
              <option value="NOSELECTION">Invoice Status</option>
              <option value="REJECTED">Rejected</option>
              <option value="SUBMITTED">Submitted</option>
            </select>
          </td>

          <td>
            <select
              name="invoice_type"
              value={Filters.invoice_type}
              onChange={handleFilterChange}
            >
              <option value="NOSELECTION">Select Invoice Type</option>
              <option value="INV">INV</option>
              <option value="DBN">DBN</option>
              <option value="CRN">CRN</option>
            </select>
          </td>
          <td class="DatePickerStyle">
            <DatePicker
              value={Filters.month || moment(new Date()).format("MM-YYYY")}
              name="month"
              required
              onChange={(searchdate) => FilterDate(searchdate)}
              placeholderText="Month-Year"
              showMonthYearPicker
              dateFormat={"MMM-yyyy"}
            />
          </td>
          <td>
            <button
              type="button"
              className="button"
              name="search"
              onClick={() =>
                SearchInvoices(
                  Filters.partner_code,
                  Filters.lob,
                  Filters.gst,
                  Filters.invoice_status,
                  Filters.invoice_type,
                  Filters.month
                )
              }
            >
              Search
            </button>
          </td>
        </tr>
        <div></div>
      </table>

      <div className="dashboard-cards">
      </div>
      <div className="content-area-table">
        <div className="data-table-info">
          {/* <h4 className="data-table-title">Latest Invoices</h4> */}
        </div>
        <div className="data-table-diagram">
          <table>
            <thead>
              <tr>
                {TABLE_HEADS?.map((th, index) => (
                  <th key={index}>{th}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {/* { ₹
                          {new Intl.NumberFormat("en-IN").format(
                            row.total_invoice_amount
                          )}}          */}
              {/* {console.log(TABLE_DATA)} */}
              {TABLE_DATA?.map((dataItem, index) => {
                return (
                  <tr key={dataItem.invoice_id}>
                    {/* <tr key={index}></tr> */}
                    {/* <td>{dataItem.invoice_id}</td> */}
                    <td>{dataItem.lob}</td>
                    <td>{dataItem.document_no}</td>
                    {/* <td>{dataItem.invoice_date}</td> */}
                    <td>
                      {new Date(dataItem.invoice_date)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })
                        .replace(/\//g, "-")}
                    </td>
                    <td>{dataItem.document_type}</td>
                    <td>
                      {new Intl.NumberFormat("en-IN", {
                        style: "currency",
                        currency: "INR",
                      }).format(dataItem.total_invoice_amount)}
                      {/* {dataItem.total_invoice_amount} */}
                    </td>
                    {/*    <td>{dataItem.invoice_status}</td>  */}
                    <td>
                      {dataItem.invoice_status === "Draft" ? (
                        <span
                          className="clickable"
                          onClick={() => handleDraftClick(dataItem.invoice_id)}
                        >
                          {dataItem.invoice_status}
                        </span>
                      ) : (
                        dataItem.invoice_status
                      )}
                    </td>
                    <td>{dataItem.invoice_processing_status || ""}</td>
                    {/* <td>{dataItem.reject_msg || ""}</td> */}
                    {/* <td title={dataItem.reject_msg}>
                      {dataItem.reject_msg
                        ? dataItem.reject_msg.slice(0, 15) + "..."
                        : ""}
                    </td> */}
                    {/* <td
                      title={dataItem.reject_msg}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "10px",
                        cursor:
                          dataItem.reject_msg && dataItem.reject_msg.length > 20
                            ? "pointer"
                            : "default",
                      }}
                    >
                      {dataItem.reject_msg
                        ? dataItem.reject_msg.slice(0, 20) + "..."
                        : ""}
                    </td> */}
                    <td
                      title={
                        dataItem.reject_msg && dataItem.reject_msg.length > 14
                          ? dataItem.reject_msg
                          : ""
                      }
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "10px",
                        cursor:
                          dataItem.reject_msg && dataItem.reject_msg.length > 14
                            ? "pointer"
                            : "default",
                      }}
                    >
                      {dataItem.reject_msg
                        ? dataItem.reject_msg.slice(0, 14) +
                        (dataItem.reject_msg.length > 14 ? "..." : "")
                        : ""}
                    </td>
                    {/* <td
                      style={{
                        whiteSpace: "nowrap", // Initially keep it in one line with ellipsis
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "200px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.whiteSpace = "pre-wrap"; // Allow multi-line text
                        e.target.style.overflow = "visible"; // Ensure full text is shown
                        e.target.innerText = dataItem.reject_msg; // Show full text
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.whiteSpace = "nowrap"; // Revert back to single-line ellipsis
                        e.target.style.overflow = "hidden"; // Hide overflow
                        e.target.innerText = dataItem.reject_msg
                          ? dataItem.reject_msg.slice(0, 20) + "..."
                          : "";
                      }}
                    >
                      {dataItem.reject_msg
                        ? dataItem.reject_msg.slice(0, 20) + "..."
                        : ""}
                    </td> */}

                    {/* <td>{dataItem.payment_status || ""}</td> */}
                    <td>
                      {dataItem.payment_status?.trim().toUpperCase() === "PAID"
                        ? "PAID"
                        : ""}
                    </td>
                    {/* <td>{dataItem.utr_number || ""}</td> */}
                    <td>
                      {dataItem.utr_number && (
                        <span>{dataItem.utr_number}</span>
                      )}
                      {dataItem.utr_date && <br />}
                      {dataItem.utr_date && <span>{dataItem.utr_date}</span>}
                    </td>

                    {/* <-- Display Processing Status */}
                    {/* <td>
                      <div className="dt-status">
                        <span
                          className={`dt-status-dot dot-${dataItem.status}`}></span>
                        <span className="dt-status-text">
                          {dataItem.total_invoice_amount}
                        </span>
                      </div>
                    </td> */}
                    {/* <td>${dataItem.amount}</td> */}
                    {/* <td className="dashboard-table-action-cell"> */}
                    {/* <AreaTableAction />  */}
                    {/* <Button>
                        <MoreHorizRoundedIcon />
                      </Button> */}
                    {/* </td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
